<template>
    <div>
        <h2 class="order-edit-modal__heading">{{ title }}</h2>
        <div class="order-edit-modal__interval">
            <div
                v-for="(i, index) in orderableIntervals"
                :key="`interval-mo-${index}`"
                class="radio"
            >
                <label>
                    <input
                        v-if="mode === 'business'"
                        :name="`delivery-interval-${day}`"
                        :value="i.id"
                        :checked="intervals[day] === i.id"
                        type="radio"
                        @change="setDeliveryInterval(i.id, day)"
                    >
                    <input
                        v-else
                        :value="i.id"
                        :checked="intervals === i.id"
                        name="delivery-interval"
                        type="radio"
                        @change="setDeliveryInterval(i.id)"
                    >
                    <span class="custom-radio"/>
                    {{ i.name }}
                </label>
            </div>
        </div>
        <div class="order-edit-modal__baskets">
            <h3 :class="{'private': mode === 'private'}" class="order-edit-modal__sub-heading">{{ subscriptionName }}-Korb</h3>
            <p v-if="mode === 'private'">Stelle deine gewünschte Gesamtmenge aus unseren drei Grössen an Körben zusammen</p>
            <div :class="{'private': mode === 'private'}" class="order-edit-modal__baskets__container">
                <div
                    v-for="(basket, index) in orderableBaskets"
                    :key="`basket-${index}`"
                >
                    <div class="order-edit-modal__baskets__item">
                        <div class="order-edit-modal__baskets__weight-container">
                            <div class="order-edit-modal__baskets__weight-text">{{ basket.kg }} kg</div>
                        </div>
                        <basket-input
                            :day="day"
                            :basket="basket"
                            :value="basketsCount(day, basket.id)"
                            :edit-basket="editBasket"
                            :change-on-recommendations="true"
                        />
                    </div>
                    <div class="order-edit-modal__baskets__info business">
                        <span
                            class="order-edit-modal__baskets__item__price"
                        >
                            à {{ orderableBasketsPrices[index].price | round | formatPrice }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="order-edit-modal__baskets__info business">
                <span
                    class="order-edit-modal__baskets__item__price"
                >
                    Total {{ totalWeight(day) }} kg / Lieferung
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import BasketInput from './BasketInput.vue';

import filters from '../mixins/filters';

export default {
    components: {
        BasketInput,
    },
    mixins: [
        filters,
    ],
    props: {
        title: {
            type: String,
            required: true,
        },
        day: {
            type: String,
            required: true,
        },
        orderableIntervals: {
            type: Array,
            required: true,
        },
        intervals: {
            type: [Object, Number],
            required: true,
        },
        orderableBaskets: {
            type: Array,
            required: true,
        },
        baskets: {
            type: [Object, Array],
            required: true,
        },
        setDeliveryInterval: {
            type: Function,
            required: true,
        },
        editBasket: {
            type: Function,
            required: true,
        },
    },
    computed: {
        ...mapState({
            mode: state => state.mode,
            subscriptionTypes: state => state.orderable.product_groups,
        }),
        subscriptionName() {
            return this.$store.getters['subscriptionType'].name;
        },
        subscriptionType() {
            return this.$store.getters['subscriptionType'].id;
        },
        orderableBasketsPrices() {
            if (this.subscriptionTypes) {
                const subscriptionType = this.subscriptionTypes.find(
                    s => s.id === this.subscriptionType,
                );
                if (subscriptionType) {
                    return subscriptionType.variants;
                }
                return [];
            }
            return [];
        },
    },
    methods: {
        basketsCount(day, id) {
            if (this.mode === 'business') {
                return this.baskets[day].filter(b => b.id === id).length;
            }
            return this.baskets.filter(b => b.id === id).length;
        },
        totalWeight(day) {
            if (this.mode === 'business') {
                return this.baskets[day].map(i => i.kg).reduce((a, b) => a + b, 0);
            }
            return this.baskets.map(i => i.kg).reduce((a, b) => a + b, 0);
        },
    },
};
</script>



// WEBPACK FOOTER //
// DeliveryDay.vue?82f2830c